import { useState } from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Button,
  Checkbox,
  Collapse,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  IconButton,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography
} from '@mui/material';

import {
  AddCircleOutlined,
  AttachFileOutlined,
  CancelOutlined,
  Check,
  CloseOutlined,
  KeyboardArrowDownOutlined
} from '@mui/icons-material';

import {
  categoryRowSx,
  categorySaveButtonSx,
  clinicalCategoryLabelSx,
  clinicalCategoryTextSx,
  closeButtonSx, dialogContentSx,
  dialogPaperSx, getCategoryActionButtonSx, newCategoryFieldSx,
  newCategoryRowSx,
  selectedFileTextSx,
  selectDocumentButtonSx, newCategoryControlSx
} from '../../../../Common/components/Styles/UploadDocStyles';
import {
  dialogHeaderStyles, menuProps,
  textFieldSx
} from '../../../../Common/components/Styles/InputStyles';
import CommonDialogActions from '../../../../Common/components/CommonDialogActions';

const categories = ['Laboratory', 'Radiology', 'Pathology'];

const UploadDoc = ({ open, onClose }) => {
  const [isEdit, setIsEdit] = useState(false);
  const [category, setCategory] = useState('');
  const [newCategory, setNewCategory] = useState('');
  const [documentTitle, setDocumentTitle] = useState('');
  const [isClinicalCategory, setIsClinicalCategory] = useState(true);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleClose = () => {
    setIsEdit(false);
    setCategory('');
    setNewCategory('');
    setDocumentTitle('');
    setIsClinicalCategory(true);
    setSelectedFile(null);

    onClose?.();
  };

  const handleSubmit = () => {
    console.log({
      category,
      newCategory,
      documentTitle,
      isClinicalCategory,
      selectedFile
    });

    handleClose();
  };

  const canSubmit =
    Boolean(category) && Boolean(documentTitle.trim()) && Boolean(selectedFile);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={false}
      slotProps={{
        paper: {
          sx: dialogPaperSx
        }
      }}>
      <DialogTitle sx={dialogHeaderStyles.dialogheader}>
        <Box>
          <Typography sx={dialogHeaderStyles.title}>Upload Document</Typography>
        </Box>

        <IconButton
          aria-label="Close"
          onClick={handleClose}
          sx={dialogHeaderStyles.dialogheaderclose}>
          <CloseOutlined sx={closeButtonSx} />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={dialogContentSx}>
        <Stack spacing={1.5}>
          <Box sx={categoryRowSx}>
            <FormControl
              sx={{
                ...textFieldSx,...newCategoryFieldSx,
                width: '100%',
              }}>
              <Select
                fullWidth
                displayEmpty
                value={category}
                onChange={event => setCategory(event.target.value)}
                IconComponent={KeyboardArrowDownOutlined}
                MenuProps={menuProps}>
                <MenuItem value="">Select Category</MenuItem>

                {categories.map(item => (
                  <MenuItem key={item} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Button
              variant="contained"
              onClick={() => setIsEdit(prev => !prev)}
              sx={getCategoryActionButtonSx(isEdit)}>
              {isEdit ? <CancelOutlined /> : <AddCircleOutlined />}
            </Button>
          </Box>

          <Collapse in={isEdit} timeout={250} unmountOnExit>
            <Box>
              <Box sx={newCategoryRowSx}>
                <FormControl fullWidth sx={newCategoryControlSx}>
                  <TextField
                    fullWidth
                    placeholder="Name of new category"
                    value={newCategory}
                    onChange={event => setNewCategory(event.target.value)}
                    sx={{...textFieldSx,...newCategoryFieldSx}}
                  />

                  <Button
                    variant="contained"
                    onClick={() => setIsEdit(false)}
                    sx={categorySaveButtonSx}>
                    <Check />
                  </Button>
                </FormControl>
              </Box>

              <FormControlLabel
                sx={clinicalCategoryLabelSx}
                control={
                  <Checkbox
                    checked={isClinicalCategory}
                    onChange={event =>
                      setIsClinicalCategory(event.target.checked)
                    }
                    size="small"
                  />
                }
                label={
                  <Typography sx={clinicalCategoryTextSx}>
                    Clinical Category
                  </Typography>
                }
              />
            </Box>
          </Collapse>

          <TextField
            fullWidth
            placeholder="Document Title"
            value={documentTitle}
            onChange={event => setDocumentTitle(event.target.value)}
            sx={{ ...textFieldSx }}
          />

          <Button
            variant="outlined"
            component="label"
            startIcon={<AttachFileOutlined />}
            sx={selectDocumentButtonSx}>
            Select Document
            <input
              hidden
              type="file"
              accept="image/*,.pdf,.doc,.docx"
              onChange={event =>
                setSelectedFile(event.target.files?.[0] || null)
              }
            />
          </Button>

          {selectedFile && (
            <Typography sx={selectedFileTextSx}>
              Selected: {selectedFile.name}
            </Typography>
          )}
        </Stack>
      </DialogContent>
      <CommonDialogActions
        onCancel={handleClose}
        onSubmit={handleClose}
        submitText="UPLOAD"
        disabled={!canSubmit}
      />

      {/* <DialogActions sx={dialogActionsSx}>
        <Button variant="outlined" onClick={handleClose} sx={cancelButtonSx}>
          Cancel
        </Button>

        <Button
          variant="contained"
          disabled={!canSubmit}
          onClick={handleSubmit}
          sx={submitButtonSx}>
          Submit
        </Button>
      </DialogActions> */}
    </Dialog>
  );
};

UploadDoc.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func
};

export default UploadDoc;
